import { defineComponent as _defineComponent } from 'vue'
import StoreUpload from '../components/StoreUpload.vue';
import router from '../router/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreUploadView',
  setup(__props) {


const breadcrumbItems = [
  {
    text: 'Stores',
    disabled: false,
    href: router.match({
      name: 'stores',
    }).path,
  },
  {
    text: router.currentRoute.params.store,
    disabled: false,
    href: router.match({
      name: 'storeUploads',
      params: {
        store: router.currentRoute.params.store,
      },
    }).path,
  },
  {
    text: router.currentRoute.params.upload,
    disabled: false,
    href: router.match({
      name: 'storeUpload',
      params: {
        store: router.currentRoute.params.store,
        upload: router.currentRoute.params.upload,
      },
    }).path,
  },
]


return { __sfc: true,breadcrumbItems, StoreUpload }
}

})